import React, { useState, useEffect } from 'react';
import { Colors, Text } from 'library';
import { Grid } from '@material-ui/core';
import { UserPostModel, FamilyRoleInfo, ProviderRoleInfo } from '../../NewsfeedModels';
import LocationOnOutlinedIcon from '@material-ui/icons/LocationOnOutlined';
import WorkOutlineOutlinedIcon from '@material-ui/icons/WorkOutlineOutlined';
import ChildCareIcon from '@material-ui/icons/ChildCare';
import PetsIcon from '@material-ui/icons/Pets';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import StarOutlineIcon from '@material-ui/icons/StarOutline';

interface IProps {
    user: UserPostModel;
}

type BulletType = { icon: JSX.Element; text: string };

export default function BulletSection({ user }: IProps) {
    const [bullets, setBullets] = useState<BulletType[]>([]);

    const familyBullets: BulletType[] = [
        {
            icon: <WorkOutlineOutlinedIcon fontSize="small" style={{ color: Colors.turquoise }} />,
            text: `Hired ${(user.role_info as FamilyRoleInfo).provider_hires} providers`,
        },
    ];

    const providerBullets: BulletType[] = [
        {
            icon: <AccessTimeIcon fontSize="small" style={{ color: Colors.turquoise }} />,
            text: (user.role_info as ProviderRoleInfo).last_active,
        },
    ];

    function get_family_kids_bullet() {
        if ((user.role_info as FamilyRoleInfo).kids.kids > 0) {
            familyBullets.push({
                icon: <ChildCareIcon fontSize="small" style={{ color: Colors.turquoise }} />,
                text: `${(user.role_info as FamilyRoleInfo).kids.kids} kids`,
            });
        }
    }

    function get_family_pets_bullet() {
        if ((user.role_info as FamilyRoleInfo).kids.pets > 0) {
            familyBullets.push({
                icon: <PetsIcon fontSize="small" style={{ color: Colors.turquoise }} />,
                text: `${(user.role_info as FamilyRoleInfo).kids.pets} pets`,
            });
        }
    }

    function get_provider_rating() {
        if ((user.role_info as ProviderRoleInfo).rating > 0) {
            providerBullets.push({
                icon: <StarOutlineIcon fontSize="small" style={{ color: Colors.turquoise }} />,
                text: `${(user.role_info as ProviderRoleInfo).rating}`,
            });
        }
    }

    function get_provider_jobs() {
        let text = '';
        if ((user.role_info as ProviderRoleInfo).jobs_completed > 0) {
            text = `${(user.role_info as ProviderRoleInfo).jobs_completed} Jobs Completed`;
        } else {
            text = 'New to Tandem!';
        }

        providerBullets.push({
            icon: <WorkOutlineOutlinedIcon fontSize="small" style={{ color: Colors.turquoise }} />,
            text: text,
        });
    }

    function get_location(bulletList: BulletType[]) {
        if (
            user.address[0] !== undefined &&
            user.address[0].city !== undefined &&
            user.address[0].state !== undefined
        ) {
            bulletList.unshift({
                icon: <LocationOnOutlinedIcon fontSize="small" style={{ color: Colors.turquoise }} />,
                text: `${user.address[0].city}, ${user.address[0].state}`,
            });
        }
    }

    function handleFamilyBullets() {
        get_location(familyBullets);
        get_family_kids_bullet();
        get_family_pets_bullet();
        setBullets(familyBullets);
    }

    function handleProviderBullets() {
        get_location(providerBullets);
        get_provider_rating();
        get_provider_jobs();
        setBullets(providerBullets);
    }

    useEffect(() => {
        user.role === 'FAMILY' ? handleFamilyBullets() : handleProviderBullets();
    }, []);

    return (
        <Grid container item direction="column" style={{ paddingTop: 10, paddingLeft: 10 }}>
            {bullets.map((bullet, index) => {
                return (
                    <Grid item style={{ alignItems: 'center', paddingBottom: 7 }} key={index}>
                        {bullet.icon}
                        <Text variant="body2" textStyle={{ paddingLeft: 5 }}>
                            {bullet.text}
                        </Text>
                    </Grid>
                );
            })}
        </Grid>
    );
}
